import type { ReactNode } from 'react';
import { cn } from '@rocco/utils/cn';

interface HDEDesktopFrameProps {
    children: ReactNode;
    className?: string;
}

/**
 * Provides the shared HDE desktop max-width frame.
 */
export const HDEDesktopFrame = ({
    children,
    className,
}: HDEDesktopFrameProps) => (
    <div className={cn('w-full qhd:mx-auto qhd:max-w-[1920px]', className)}>
        {children}
    </div>
);
